import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-racing-dark text-white">
      <Helmet>
        <title>Page Not Found | FR:RM</title>
        <meta name="description" content="The page you're looking for couldn't be found. Return to Front Runner: Racehorse Manager's homepage to continue your horse racing journey." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Navigation />
      <main className="container mx-auto px-4 py-24 md:py-32 flex flex-col items-center justify-center text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Page Not Found</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
